import { GetMainMenuItemsParams, MenuItemDef } from "ag-grid-enterprise";
import { global } from "@shared/libs/Global";
// [보류] 항목 복원의 SYSTEM 권한 확인을 되살릴 때 함께 주석 해제한다.
// import { confirmSystemPassword } from "@widgets/commonpopup/sys/confirmSystemPassword";

export function createMainMenuItems(
  params: GetMainMenuItemsParams,
  options: {
    seq: number | undefined;
    resizeController: any;
    columnSave: () => void;
    headerChange: () => void;
    columnInit: () => void;
    filterBoxRef: React.RefObject<{ openFilterBox: () => void }>;
    enableRowDrag: () => void;
    props: any;
  }
): (MenuItemDef | string)[] {
  const {
    seq,
    resizeController,
    columnSave,
    headerChange,
    columnInit,
    filterBoxRef,
    enableRowDrag,
    props,
  } = options;
  console.log("header menu params:", resizeController);
  // 항목 복원은 모든 사용자/모든 컬럼에서 노출한다.
  // ag-grid 기본 "columnChooser"는 클릭 즉시 열려서 권한 확인을 끼워넣을 수 없어
  // 동일한 이름/아이콘의 커스텀 항목으로 대체한다.
  //
  // [보류] SYSTEM 권한 확인은 요청에 따라 잠시 꺼 둔다(나중에 되살릴 예정).
  // 되살릴 때는 아래 action 본문과 파일 상단의 confirmSystemPassword import를
  // 함께 주석 해제하면 된다.
  const columnChooserItem: MenuItemDef = {
    name: "항목 복원",
    icon: '<span class="ag-icon ag-icon-columns" role="presentation" unselectable="on"></span>',
    action: async () => {
      // if (await confirmSystemPassword()) {
      //   params.api.showColumnChooser();
      // }
      params.api.showColumnChooser();
    },
  };

  // const columnId = null;
  const columnId = params.column?.getColId();
  if (columnId === "fixIndicator") {
    // No. 컬럼은 기본 메뉴를 그대로 쓰되, 항목 복원만 커스텀 항목으로 교체한다.
    return [
      ...(params.defaultItems ?? []).map((item) =>
        item === "columnChooser" ? columnChooserItem : item
      ),
      "separator",
      {
        name: "사이즈 초기화",
        disabled: (() => {
          const menuSize = localStorage.getItem("menuSize");
          if (!menuSize) return true;
          const cd_menu = props.menuInfo?.cd_menu;
          if (!cd_menu) return true;
          const parsed = JSON.parse(menuSize);
          const gridSizes = parsed[cd_menu];
          if (!gridSizes) return true;
          return false;
        })(),
        action: () => {
          const defaultSize = resizeController?.defaultSize || {};
          const onResizeStop = resizeController?.onResizeStop;
          if (!onResizeStop) return;
          Object.entries(defaultSize).forEach(([key, value]) => {
            const match = key.match(/\d+/);
            if (match) {
              const seq = Number(match[0]);
              onResizeStop(seq, value, { skipStorage: true });
            }
          });
          const cd_menu = props.menuInfo?.cd_menu;
          if (!cd_menu) return;
          const menuSize = localStorage.getItem("menuSize");
          if (!menuSize) return;
          const parsed = JSON.parse(menuSize);
          delete parsed[cd_menu];
          localStorage.setItem("menuSize", JSON.stringify(parsed));
        },
      },
    ];
  }

  const athleteMenuItems: (MenuItemDef | string)[] = [
    ...(global.getState().userInfo.cd_user === "SYSTEM"
      ? [
          {
            name: "항목설정저장",
            action: columnSave,
          },
          {
            name: "항목명변경",
            action: headerChange,
          },
          {
            name: "항목 제거",
            action: () => {
              //const columnId = params.column.getColId();
              //params.api.setColumnVisible(columnId, false);
            },
          },
        ]
      : []),
  ];

  // 아래 tail 필터는 인덱스 기준이라 컬럼마다 자르는 항목이 달라진다.
  // 그래서 항목 복원은 여기서 명시적으로 넣고 tail에서는 이름으로 항상 제외한다.
  athleteMenuItems.push(columnChooserItem);

  if (global.getState().userInfo.cd_user === "SYSTEM") {
    athleteMenuItems.push({
      name: "항목 초기화",
      action: columnInit,
    });
  }

  athleteMenuItems.push(
    ...params.defaultItems.filter(
      (item, index) =>
        item !== "columnChooser" && ![0, 1, 9, 10, 11].includes(index)
    )
  );

  athleteMenuItems.push(
    "separator",
    {
      name: "필터/ 필터해제",
      action: () => {
        const headerIcons = document.querySelectorAll(
          ".ag-header-cell .ag-header-icon"
        );
        headerIcons.forEach((icon) => {
          icon.classList.toggle("hidden-filter");
        });
      },
    },
    {
      name: "찾기",
      action: () => {
        filterBoxRef.current?.openFilterBox();
      },
    },
    {
      name: "순서변경",
      action: () => {
        setTimeout(() => {
          enableRowDrag();
        }, 100);
      },
    }
  );
  return athleteMenuItems;
}
